export default {
    code: 'コード',
    closetype: '区分',
    closetypename: '締グループ名',
    totalling: '集計期間',
    memo: 'メモ'
};
